import { link } from '@src/graphql/http-link'
import store from '@state/store'

// Resolve a scanned QR code to its device, then redirect. Extracted from the
// `/qr/:id` route guard so its branches can be unit-tested:
//   - found     -> the device's detail page, carrying the code (?qr=), which
//                  is the only key the public view accepts for a visitor
//                  who is not logged in
//   - no match  -> home
//   - error     -> a warning toast, then home
// The server (GET /qr/:id) responds with { ok, deviceId } (or { ok: false,
// message }); link.bowvue_base_uri resolves the correct backend per environment.
export function resolveQrCode(routeTo, routeFrom, next) {
  const id = routeTo.params.id
  return fetch(link.bowvue_base_uri + '/qr/' + id, {
    mode: 'cors',
  })
    .then(async (response) => {
      const j = await response.json()
      if (!j.ok) {
        throw new Error(j.message)
      }
      return j
    })
    .then((data) => {
      const deviceId = data.deviceId
      if (deviceId) {
        next({
          name: 'device-detail',
          params: {
            deviceId: deviceId,
          },
          query: { qr: id },
        })
        return
      }
      next({
        name: 'home',
      })
    })
    .catch((err) => {
      store.dispatch('messages/setNewMessage', {
        message: err.message,
        type: 'warning',
      })
      next({
        name: 'home',
      })
    })
}
